var app = angular.module('leonardo');

// Response details that definitively mean the token itself is no longer usable.
// Matching on the message alone is what let backend-api#1601 (403 'Token found
// in Redis' -> 401 'Token has been revoked') silently disable logout for weeks,
// so the list is a refinement on top of the status check rather than the only
// signal: any 401 still reports an auth failure, and only these complete a
// logout. Anything else may be a transient failure in the auth/routing layer,
// where destroying a still-valid session would be worse than surfacing an error.
var TOKEN_INVALID_DETAILS = [
  'Token has been revoked',
  'Given token not valid for any token type',
  'Incorrect authentication credentials.'
];

// The login endpoint answers 401 for bad user-supplied credentials, which is a
// failed sign-in rather than an invalidated session.
function isCredentialEndpoint(url) {
  return url.includes('/api-token-auth');
}

var HttpInterceptor = function($q, $location, $rootScope, NotificationService) {
  return {
    'request': function (config) {
      config.headers['Time-Zone'] = jstz.determine().name();
      return config;
    },
    'responseError': function(rejection) {
      angular.noop();
      var config = rejection ? rejection.config : null;
      var status = rejection ? rejection.status : null;
      if (config && config.url.includes('/api/')) {
        if (status === 503 && !$location.url().includes('/maintenance') && !config.url.includes('/statsig/')) {
          $location.url('/maintenance');
        }
        else if (status !== 503 && status !== -1) {
          var noError = null;
          if (config.data && config.data.noerror) {
            noError = config.data.noerror;
          }
          else {
            noError = (config.params ? config.params.noerror : false);
          }
          var errorMessage = rejection.data?.detail;
          var hasStoredToken = !isNull(localStorage.getItem('jwt_token'));
          if (status === 401 && hasStoredToken && !isCredentialEndpoint(config.url)) {
            // This request will keep failing for as long as the current token is
            // in play, so tell callers to stop re-issuing it (run/redirection.js).
            $rootScope.$broadcast('auth-failure:unauthorized', { detail: errorMessage });

            if (TOKEN_INVALID_DETAILS.indexOf(errorMessage) !== -1) {
              $rootScope.$broadcast('token-auth:deleted');
            }
            else if (!noError) {
              NotificationService.error(rejection);
            }
          }
          else if (!noError && !isCredentialEndpoint(config.url)) {
            NotificationService.error(rejection);
          }
        }
      }
      return $q.reject(rejection);
    }
  };
};

app.factory('HttpInterceptor', ['$q', '$location', '$rootScope', 'NotificationService', HttpInterceptor]);